<template>
  <div
    class="
      overflow-hidden
      grid grid-cols-2
      layout-padding
      mt-[100px]
      md:gap-x-10
      lg:gap-x-20
    "
  >
    <div
      class="
        mt-10
        col-span-2
        h-[250px]
        md:col-span-1
        lg:h-full
        bg-cover bg-no-repeat bg-center
      "
      style="background-image: url(/static/images/contact-us.jpg)"
    ></div>
    <div class="col-span-2 md:col-span-1 pt-10">
      <!-- <PageTitle :title="content.contactUs" :parentTitle="content.home" /> -->
      <div class="font-bold text-2xl lg:text-4xl py-2">
        {{ content.getInTouch }}
      </div>
      <div class="my-5">
        {{ content.feelFreeToContactUs }}
      </div>
      <div class="mt-10 grid grid-cols-2 lg:gap-x-10 gap-y-3">
        <div class="col-span-2 lg:col-span-1">
          <label class="label">{{ content.fullName }}</label>
          <input
            type="text"
            v-model="name"
            class="w-full"
            :placeholder="content.fullName"
          />
          <div class="error">{{ errors.name }}</div>
        </div>
        <div class="col-span-2 lg:col-span-1">
          <label class="label">{{ content.phone }}</label>
          <input
            type="text"
            v-model="phone"
            class="w-full"
            :placeholder="content.phone"
          />
          <div class="error">{{ errors.phone }}</div>
        </div>
        <div class="col-span-2">
          <label class="label">{{ content.email }}</label>
          <input
            type="email"
            v-model="email"
            class="w-full"
            :placeholder="content.email"
          />
          <div class="error">{{ errors.email }}</div>
        </div>
        <div class="col-span-2">
          <label class="label">{{ content.message }}</label>
          <textarea
            type="message"
            v-model="message"
            class="w-full resize-none h-36"
            :placeholder="content.message"
          />
          <div class="error">{{ errors.message }}</div>
          <div class="text-green-600" v-if="success">
            {{ content.messageHasBeenSentSuccessfully }}
          </div>
        </div>
        <div class="col-span-2">
          <div class="error" :class="{ 'my-3': errors.form }">
            {{ errors.form }}
          </div>
          <div class="w-full flex justify-end">
            <div
              class="
                py-4
                px-10
                bg-primary
                w-max
                transition-all
                duration-700
                hover:bg-secondary
                cursor-pointer
              "
              @click="submitForm"
            >
              {{ content.submit }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="emails.length > 0 || phones.length > 0 || addresses.length > 0"
    class="
      my-10
      layout-margin
      lg:p-10
      p-7
      bg-primary
      rounded-md
      flex
      justify-between
      items-center
      flex-wrap
    "
  >
    <div class="ltr:mr-10 rtl:ml-10 my-2" v-if="emails.length > 0">
      <div class="text-base font-bold mb-2">{{ content.email }}</div>
      <div class="mb-2 last-of-type:mb-0" v-for="email in emails" :key="email">
        {{ email }}
      </div>
    </div>
    <div class="ltr:mr-10 rtl:ml-10 my-2" v-if="phones.length > 0">
      <div class="text-base font-bold mb-2">{{ content.phone }}</div>
      <div class="mb-2 last-of-type:mb-0" v-for="phone in phones" :key="phone">
        {{ phone }}
      </div>
    </div>
    <div class="ltr:mr-10 rtl:ml-10 my-2" v-if="addresses.length > 0">
      <div class="text-base font-bold mb-2">{{ content.address }}</div>
      <div
        class="mb-2 last-of-type:mb-0"
        v-for="address in addresses"
        :key="address"
      >
        {{ address }}
      </div>
    </div>
  </div>
</template>
<script>
import recaptcha from "../assets/js/Recaptcha.js";
import { validate } from "../assets/js/Validation.js";
export default {
  inject: ["content"],
  data() {
    return {
      name: null,
      email: null,
      phone: null,
      message: null,
      token: null,
      errors: {
        name: null,
        email: null,
        phone: null,
        message: null,
        form: null,
      },
      success: false,
    };
  },
  computed: {
    contacts() {
      return this.$store.getters["contact/contacts"];
    },
    emails() {
      let emails = [];
      this.contacts.filter((contact) => {
        if (contact.type == "email") {
          emails.push(contact.value);
        }
      });
      return emails;
    },
    phones() {
      let phones = [];
      this.contacts.filter((contact) => {
        if (contact.type == "phone") {
          phones.push(contact.value);
        }
      });
      return phones;
    },
    addresses() {
      let addresses = [];
      this.contacts.filter((contact) => {
        if (contact.type == "address") {
          addresses.push(contact.value);
        }
      });
      return addresses;
    },
  },
  mounted() {
    recaptcha.load();
  },
  unmounted() {
    recaptcha.unload();
  },
  methods: {
    async recaptcha() {
      let grecaptcha = await window.grecaptcha;
      return new Promise((resolve, reject) => {
        grecaptcha.ready(async () => {
          await grecaptcha
            .execute("6Lf-d90hAAAAANMvuH7MP-5MNi_lsiwcWChzA0Sh", {
              action: "submit",
            })
            .then(async (token) => {
              this.token = await token;
              resolve();
            })
            .catch((err) => {
              reject(err);
            });
        });
      });
    },
    async submitForm() {
      this.errors.name = validate("required", this.name);
      this.errors.email = validate("email", this.email);
      this.errors.phone = validate("phone", this.phone);
      this.errors.message = validate("required", this.message);
      if (
        !this.errors.name &&
        !this.errors.email &&
        !this.errors.phone &&
        !this.errors.message
      ) {
        try {
          await this.recaptcha();
          await this.$store.dispatch("contact/submitContact", {
            name: this.name,
            email: this.email,
            phone: this.phone,
            message: this.message,
            token: this.token,
          });
          this.success = true;
          setTimeout(() => {
            this.success = false;
          }, 5000);
        } catch (error) {
          this.errors.form = this.content.tryAgainLater;
        }
      }
    },
  },
};
</script>

<style>
  .grecaptcha-badge {
    visibility: hidden;
  }
  </style>
  